export const POSTCODE_REGEX = /^(GIR[ ]?0AA)$|^([A-PR-UWYZ][0-9][ ]?[0-9][ABD-HJLNPQ-UW-Z]{2})$|^([A-PR-UWYZ][0-9][0-9][ ]?[0-9][ABD-HJLNPQ-UW-Z]{2})$|^([A-PR-UWYZ][A-HK-Y0-9][0-9][ ]?[0-9][ABD-HJLNPQ-UW-Z]{2})$|^([A-PR-UWYZ][A-HK-Y0-9][0-9][0-9][ ]?[0-9][ABD-HJLNPQ-UW-Z]{2})$|^([A-PR-UWYZ][0-9][A-HJKS-UW0-9][ ]?[0-9][ABD-HJLNPQ-UW-Z]{2})$|^([A-PR-UWYZ][A-HK-Y0-9][0-9][ABEHMNPRVWXY0-9][ ]?[0-9][ABD-HJLNPQ-UW-Z]{2})$/i

export const EMAIL_REGEX = /^[a-z0-9._%+-]+@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i

export const CAR_REGISTRATION_REGEX = /(^[A-Za-z0-9\s]{1,8}$)/

export const LOAN_AMOUNT_REGEX = /^([1-8][0-9]{3}|9[0-8][0-9]{2}|99[0-8][0-9]|999[0-9]|[1-4][0-9]{4}|50000)$/

export const LOAN_LENGTH_REGEX = /^([0-9]|10)$/

export const UK_PHONE_REGEX = /^(?:0|\+?44)(?:\d\s?){9,10}$/
